
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcLogic as ObcLogicElement} from '@oicl/openbridge-webcomponents/dist/automation/logic/logic.js';
 
 
 

 
 export const ObcLogic = createComponent({
   react: React,
   tagName: 'obc-logic',
   elementClass: ObcLogicElement,
   events: {
     
   }
  });
 
 